module.exports = __webpack_public_path__ + "img/learn-bf4-basics-with-oshy.63169619.jpg";